import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import style from '../css/Bookings.module.css';
import HeaderBar from '../components/HeaderBar';
import AdminBottomTab from './AdminBottomTab';

const Bookings = () => {
	const [bookings, setBookings] = useState([]);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();

	// Fetch bookings from API
	const fetchBookings = async () => {
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/FetchAllBooking.php'
			);
			const data = await response.json();

			if (data.status) {
				const sortedBookings = data.data.sort((a, b) =>
					a.status === 'Completed' ? 1 : -1
				);
				setBookings(sortedBookings);
			} else {
				setBookings([]);
			}
		} catch (error) {
			console.error('Error fetching bookings:', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchBookings();
	}, []);

	if (loading) {
		return (
			<div className={style.loaderContainer}>
				<div className={style.loader}></div>
			</div>
		);
	}

	return (
		<div className={style.container}>
			<HeaderBar title={'Bookings'} />

			{bookings.length === 0 ? (
				<p className={style.noData}>No bookings available</p>
			) : (
				<div className={style.listContainer}>
					{bookings.map((item) => (
						<div
							key={item.order_number}
							className={style.bookingItem}
							onClick={() => navigate(`/detail/${item.order_number}`)}
						>
							<div>
								<p className={style.orderText}>Order: {item.order_number}</p>
								<p>{new Date(item.date).toLocaleDateString('en-GB')}</p>
							</div>
							<p
								className={`${style.statusText} ${
									item.status === 'Completed' ? style.completed : style.pending
								}`}
							>
								{item.status}
							</p>
						</div>
					))}
				</div>
			)}
			<AdminBottomTab />
		</div>
	);
};

export default Bookings;
